import React from 'react'
import PropTypes from 'prop-types'

// Outlined trash glyph from the DS (Figma 774:17948); inlined because
// FontAwesome Free has no regular-weight trash. Sizes with 1em and inherits
// The current text color.
const TRASH_PATH_1 = 'M12.1204 2.94737H9.26852V1.47368C9.26852 1.08284 9.11829 0.708001 8.85087 0.4316'
  + '32C8.58346 0.155263 8.22077 0 7.84259 0H4.99074C4.61256 0 4.24987 0.155263 3.982'
  + '46 0.431632C3.71505 0.708001 3.56481 1.08284 3.56481 1.47368V2.94737H0.712963C0.'
  + '523873 2.94737 0.342528 3.025 0.208822 3.16318C0.0751155 3.30137 0 3.48879 0 3.6'
  + '8421C0 3.87963 0.0751155 4.06705 0.208822 4.20524C0.342528 4.34342 0.523873 4.42'
  + '105 0.712963 4.42105H1.42593V12.5263C1.42593 12.9172 1.57616 13.292 1.84357 13.5'
  + '684C2.11098 13.8447 2.47367 14 2.85185 14H9.98148C10.3597 14 10.7224 13.8447 10.'
  + '9898 13.5684C11.2572 13.292 11.4074 12.9172 11.4074 12.5263V4.42105H12.1204C12.3'
  + '095 4.42105 12.4908 4.34342 12.6245 4.20524C12.7582 4.06705 12.8333 3.87963 12.8'
  + '333 3.68421C12.8333 3.48879 12.7582 3.30137 12.6245 3.16318C12.4908 3.025 12.309'
  + '5 2.94737 12.1204 2.94737ZM4.99074 1.47368H7.84259V2.94737H4.99074V1.47368ZM9.98'
  + '148 12.5263H2.85185V4.42105H9.98148V12.5263Z'
const TRASH_PATH_2 = 'M4.99074 5.15789C4.80165 5.15789 4.62031 5.23553 4.4866 5.37371C4.35289 5.5119 4'
  + '.27778 5.69931 4.27778 5.89474V11.0526C4.27778 11.2481 4.35289 11.4355 4.4866 11'
  + '.5737C4.62031 11.7118 4.80165 11.7895 4.99074 11.7895C5.17983 11.7895 5.36118 11'
  + '.7118 5.49488 11.5737C5.62859 11.4355 5.7037 11.2481 5.7037 11.0526V5.89474C5.70'
  + '37 5.69931 5.62859 5.5119 5.49488 5.37371C5.36118 5.23553 5.17983 5.15789 4.9907'
  + '4 5.15789Z'
const TRASH_PATH_3 = 'M7.84259 5.15789C7.6535 5.15789 7.47216 5.23553 7.33845 5.37371C7.20475 5.5119 7'
  + '.12963 5.69931 7.12963 5.89474V11.0526C7.12963 11.2481 7.20475 11.4355 7.33845 1'
  + '1.5737C7.47216 11.7118 7.6535 11.7895 7.84259 11.7895C8.03168 11.7895 8.21303 11'
  + '.7118 8.34673 11.5737C8.48044 11.4355 8.55556 11.2481 8.55556 11.0526V5.89474C8.'
  + '55556 5.69931 8.48044 5.5119 8.34673 5.37371C8.21303 5.23553 8.03168 5.15789 7.8'
  + '4259 5.15789Z'

const TrashIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height="1em"
    viewBox="0 0 12.8333 14"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={TRASH_PATH_1} fill="currentColor" />
    <path d={TRASH_PATH_2} fill="currentColor" />
    <path d={TRASH_PATH_3} fill="currentColor" />
  </svg>
)

TrashIcon.propTypes = {
  className: PropTypes.string
}

TrashIcon.defaultProps = {
  className: ''
}

export default TrashIcon
